import React from 'react';

import {Result} from '../components';
import {getFileTypeFromUrl} from "./utils";
import config from "../../../../config";
import {AnchorButton, Callout, Intent} from "@blueprintjs/core";
import {IconNames} from "@blueprintjs/icons";

interface ExternalFileResultProps {
  key: any;
  uid: any;
  result: any;
}

const ErrorMessage = ({result}: any) => {
  const error = result?.value?.response_json?.error || 'Unknown error';

  return <>{error}</>;
};

const SuccessMessage = ({uid, result}: any) => {
  const executionEnd = result?.value?.created_on ? new Date(result?.value?.created_on) : null;
  const response = result?.value?.response_json || {};
  const {name, s3_url} = response;
  const fileType = getFileTypeFromUrl(s3_url);

  const isPresignedURL = s3_url && s3_url.includes('Expires') && s3_url.includes('Signature');

  let downloadUrl = isPresignedURL ?
    s3_url : `${config.app.url}/api/v1/block/${uid}/export/${result.key}?type=${fileType}`;

  return (
    <Callout
      intent={Intent.SUCCESS}
      icon={IconNames.TICK}
      title={name}
    >
      {executionEnd && <div>Execution end: {executionEnd.toLocaleString()}</div>}
      {
        fileType !== 'no_type' && (
          <AnchorButton
            text={`Download ${fileType}`}
            href={downloadUrl}
            target="_blank"
            rel="noopener noreferrer"
            icon={IconNames.CLOUD_DOWNLOAD}
            intent={Intent.SUCCESS}
            style={{marginTop: '10px'}}
          />
        )
      }
    </Callout>
  );
};

const ExternalFileResult = ({
  uid,
  result,
}: ExternalFileResultProps) => {
  return (
    <Result
      result={result}
      successElement={<SuccessMessage uid={uid} result={result}/>}
      failedTitle="External File run failed"
      failedDescription={<ErrorMessage result={result}/>}
    />
  );
};

export default ExternalFileResult;
